<template>
  <div>
    <div class=" bg-top pt-0 pl-5 pr-0 max-w-main" style="background: #f5f8fd;">
        <div class="max-w-main pt-4 bg-home-vmain-new">
            <div class="">
                <img src="@/assets/default_main/logo_vclick.png" alt="logo image">
            </div>
            <div v-if="loading_step_one">
                <slide-home-page-new />
            </div>
        </div>
    </div>

    <!-- <div class="max-w-main bg-vmain rounded-t-lg" style="margin-top: -60px;">
        <div class="p-4">
            <form-input :form="form" :click-show-modal="saveCus" :loading_otp="loading_otp" />
        </div>
        <div class="p-4">
            <list-content />
        </div>
        <div class="p-4">
            <list-partner />
        </div>
        <div class="p-4 pt-0  text-center">
            <div>
                Bản quyền thuộc công ty CPĐT Vega Fintech
            </div>
            <div>
                Địa chỉ: Tầng 3, tòa nhà Hòa Bình, 106 Hoàng Quốc Việt, Cầu Giấy, Hà Nội
            </div>
            <div>
                MST: 0107815397
            </div>
        </div>
    </div> -->

    <div class="step_one pl-5 pr-5 max-w-main" v-if="loading_step_one" style="background: #f5f8fd; height: 68vh;">
        <div class="step_one_header">
            <p style="margin-bottom: 16px;">Mời quý khách lựa chọn tiêu chí mong muốn:</p>
            <p>
                <img alt="blog image" style="margin-left: 8px;margin-bottom: -18px; width: 85%;" class="inline-block" src="@/assets/default_main/model_right_c.png" >
            </p>
        </div>
        <div class="step_one_checkbox">
            <div class="w-full flex flex-row mb-2">
                <div
                    class="w-6 h-6 cursor-pointer"
                >
                    <img
                        v-if="otp1"
                        src="@/assets/default_main/Checkbox.svg"
                        class="w-full h-full"
                    />
                    <img
                        v-else
                        src="@/assets/default_main/un_checkbox.svg"
                        class="w-full h-full"
                    />
                </div>
                <div class="flex flex-1 ml-3">
                    <div class="text-sm text-[#808080]" style="color:#ff8938">
                        Tổ chức tài chính tuy tín
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row mb-2">
                <div
                    class="w-6 h-6 cursor-pointer"
                    @click="otp2=!otp2"
                >
                    <img
                        v-if="otp2"
                        src="@/assets/default_main/Checkbox.svg"
                        class="w-full h-full"
                    />
                    <img
                        v-else
                        src="@/assets/default_main/un_checkbox.svg"
                        class="w-full h-full"
                    />
                </div>
                <div class="flex flex-1 ml-3">
                    <div class="text-sm text-[#808080]" :style="{color: otp2 ? '#ff8938' : '#34404b' }">
                        Vay chỉ cần CCCD
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row mb-2">
                <div
                    class="w-6 h-6 cursor-pointer"
                    @click="otp3=!otp3"
                >
                    <img
                        v-if="otp3"
                        src="@/assets/default_main/Checkbox.svg"
                        class="w-full h-full"
                    />
                    <img
                        v-else
                        src="@/assets/default_main/un_checkbox.svg"
                        class="w-full h-full"
                    />
                </div>
                <div class="flex flex-1 ml-3">
                    <div class="text-sm text-[#808080]" :style="{color: otp3 ? '#ff8938' : '#34404b' }">
                        Duyệt nhanh trong 3 phút
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row mb-2">
                <div
                    class="w-6 h-6 cursor-pointer"
                    @click="otp4=!otp4"
                >
                    <img
                        v-if="otp4"
                        src="@/assets/default_main/Checkbox.svg"
                        class="w-full h-full"
                    />
                    <img
                        v-else
                        src="@/assets/default_main/un_checkbox.svg"
                        class="w-full h-full"
                    />
                </div>
                <div class="flex flex-1 ml-3">
                    <div class="text-sm text-[#808080]" :style="{color: otp4 ? '#ff8938' : '#34404b' }">
                        Khoản vay từ  5 - 12 triệu
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row">
                <div
                    class="w-6 h-6 cursor-pointer"
                    @click="otp5=!otp5"
                >
                    <img
                        v-if="otp5"
                        src="@/assets/default_main/Checkbox.svg"
                        class="w-full h-full"
                    />
                    <img
                        v-else
                        src="@/assets/default_main/un_checkbox.svg"
                        class="w-full h-full"
                    />
                </div>
                <div class="flex flex-1 ml-3">
                    <div class="text-sm text-[#808080]" :style="{color: otp5 ? '#ff8938' : '#34404b' }">
                        Không liên hệ người thân
                    </div>
                </div>
            </div>
        </div>
        <div class="step_one_end">
            <p>Chúng tôi sẽ tìm kiếm khoản vay phù hợp!</p>
        </div>
        <div class="mt-4">
            <div :class="{'bg-color-vmain' : input_check , 'bg-vmain-disable' : !input_check }"  class=" text-white  rounded-md text-center" :style="{ backgroundColor: BackgroundColor, borderColor: BackgroundColor }" style="background-color: #f1674a;border-radius: 80px;box-shadow: rgba(68, 0, 79, 0.1) 0px 8px 10px 0px;height: 52px;">
                <button class="font-bold-vmain p-3 w-full" :disabled="!input_check" @click="showResult"  ><b-spinner v-if="loading_otp" small type="grow"></b-spinner>&nbsp; {{ continues }}</button>
            </div>
        </div>
        <div class="step_one_info">
            <p>Bản quyền thuộc công ty CPĐT Vega Fintech</p>
            <p>Địa chỉ: Tầng 3, tòa nhà Hòa Bình, 106 Hoàng Quốc Việt, Cầu Giấy, Hà Nội</p>
        </div>
    </div>
    <div class="step_two pl-5 pr-5 max-w-main" v-if="loading_step_two" style="background: #f5f8fd; height: 86vh;">
        <div class="step_two_head">
            <p>
                Chúng tôi đã tìm thấy <span>khoản vay phù hợp</span> tại
            </p>
            <p>
                <img src="@/assets/default_main/logo_SHBF.png" style="margin-left: auto;margin-right: auto;width: 60%;" alt="blog image">
            </p>
            <p>Hệ thống sẽ tự động chuyển sang trang Đăng ký vay của đối tác SHBFinance</p>
            <p style="color: #9aa0a5;">(<span>{{ countDownPartner }}</span> giây)</p>
        </div>
        <div class="tips">
            Tips:
        </div>
        <div class="step_two_box">
            <p>Chuẩn bị sẵn sàng <span>CCCD gắn chip</span></p>
            <p>Sử dụng <span>Smartphone</span> để làm thủ tục online</p>
            <p>Sử dụng <span>Sim Viettel</span> để  phê duyệt nhanh hơn</p>
        </div>
    </div>
    
    <b-modal hide-header hide-footer centered id="modal-cmnd">
        <modal-cmnd :form="form" :click-send="saveCus" :loading_otp="loading_otp" />
    </b-modal>

    <b-modal hide-header hide-footer centered id="modal-mirae">
        <p @click="closeShowModal">
            <img src="@/assets/default_main/close-31-16.png" alt="blog image" class="close_modal">
        </p>
        <a href="https://mafc.com.vn/vay-tien-nhanh/?utm_source=VD07">
            <img alt="blog image" class="inline-block" src="@/assets/default_main/popup_mirae.png" >
        </a>
    </b-modal>

    <b-modal hide-header no-close-on-backdrop hide-footer centered id="connect-shb">
        <div class="mt-4" style="margin-top: 0 !important;">
            <p>
                <b>Chúc mừng!</b><br>
                <b>Đã tìm thấy sản phẩm vay phù hợp với bạn tại SHBFinance</b>
            </p>
        </div>
        <div>
            <p style="margin-top: 26px;">
                <img src="@/assets/default_main/bg_shb.png" alt="blog image" style="width: 80%;margin-left: auto;margin-right: auto;">
            </p>
        </div>
        <div class=" text-base font-semibold mt-3" style="margin-bottom: 30px;font-weight: 400;">
            <p>
                Tự động chuyển đến SHBFinance trong <span> ({{ countDownPartner }}s) </span>
            </p>
        </div>
        <div class="mt-2">
            <div class="bg-color-vmain text-white  rounded-md text-center">
                <button class="font-bold-vmain p-3 w-full"><a href="https://vt.shbfinance.com.vn/?utm_source=vclick">Tiếp tục tại SHBFinance</a></button>
            </div>
        </div>
    </b-modal>

    <b-modal hide-header no-close-on-backdrop hide-footer centered id="modal-otp">
        <div class="pt-3">
            <div class="color-bold-vmain text-base font-bold mt-3 text-center w-3/4 m-auto">
                Nhập mã <span class="color-main2"> OTP </span> được gửi về số điện thoại của bạn
            </div>
            <div class="mt-3 flex space-x-4">
                <div class="flex-1 ">
                    <input id="otp1" inputmode="numeric" class="w-full h-9 rounded-md focus:ring-blue-100 focus:ring-2 focus:outline-none focus:border-transparent p-1 color-bold-vmain text-center font-bold" @input="formatOTP1" v-model="otp1" style="border: 2px solid #f1674a;" placeholder="" />
                </div>
                <div class="flex-1 ">
                    <input id="otp2" inputmode="numeric" class="w-full h-9 rounded-md focus:ring-blue-100 focus:ring-2 focus:outline-none focus:border-transparent p-1 color-bold-vmain text-center font-bold" @input="formatOTP2" v-model="otp2" style="border: 2px solid #f1674a;" placeholder="" />
                </div>
                <div class="flex-1 ">
                    <input id="otp3" inputmode="numeric" class="w-full h-9 rounded-md focus:ring-blue-100 focus:ring-2 focus:outline-none focus:border-transparent p-1 color-bold-vmain text-center font-bold" @input="formatOTP3" v-model="otp3" style="border: 2px solid #f1674a;" placeholder="" />
                </div>
                <div class="flex-1 ">
                    <input id="otp4" inputmode="numeric" class="w-full h-9 rounded-md focus:ring-blue-100 focus:ring-2 focus:outline-none focus:border-transparent p-1 color-bold-vmain text-center font-bold" @input="formatOTP4" v-model="otp4" style="border: 2px solid #f1674a;" placeholder="" />
                </div>
            </div>
            <div v-if="countOtp < 3" class="flex space-x-4 mt-2">
                <div class="flex-2 color-bold-vmain">Bạn không nhận được mã?</div>
                <div class="flex-1 text-right color-main2">
                    <span v-if="countDown > 0">
                        Gửi lại OTP ({{countDown}}s)
                    </span>
                    <span class="cursor-pointer" v-else @click="reGenOtp">
                        <b-spinner v-if="loading" small type="grow"></b-spinner> <span v-else> Gửi lại OTP </span> 
                    </span>
                    
                </div>
            </div>
            <!-- <div>Gửi lại ngay</div> -->
            <div class="mt-4 mb-9">
                <button @click="confirmOTP" :disabled="loading" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg"> <b-spinner v-if="loading" small type="grow"></b-spinner> Xác nhận </button>
            </div>
        </div>
    </b-modal>

    <b-modal hide-header centered hide-footer id="modal-pending">
        <div class="text-center pt-10 pb-10">
            <div class="color-bold-vmain text-lg font-bold mt-3">
                Hệ thống đang tìm kiếm khoản vay phù hợp với bạn
            </div>
            <div class="mt-2 m-auto">
                <img class="m-auto w-1/3" src="@/assets/default/loading3.gif" >
            </div>
            <div class=" text-base font-semibold mt-3">
                Vui lòng không tắt trình duyệt hoặc ngắt kết nối <span> ({{ countDownPartner }}s) </span>
            </div>

            <div class="text-white border-b-2 ml-5 mr-5 "> .</div>

            <div class=" text-lg font-semibold mt-3 px-5">
                Cho chúng tôi biết thêm nhu cầu của bạn để tìm kiếm khoản vay nhanh hơn
            </div>

            <div class="flex items-center mt-2 py-1">
                <div class="flex-initial items-center leading-8 text-left" >
                    <img  src="@/assets/default/support.png" >
                </div>
                <div class="flex-initial items-center leading-8 ml-1">
                    <label >Tôi cần vay gấp, tư vấn sớm</label>
                </div>
                <div class="flex-auto justify-end items-center leading-8 text-right">
                    <input class="text-right" type="radio"  value="1" v-model="loan_demand">
                </div>
            </div>

            <div class="flex items-center py-1">
                <div class="flex-initial items-center leading-8 text-left" >
                    <img  src="@/assets/default/search.png" >
                </div>
                <div class="flex-initial items-center leading-8  ml-1">
                    <label  >Tôi đang tham khảo và quyết định sau</label>
                </div>
                <div class="flex-auto justify-end items-center leading-8 text-right">
                    <input class="text-right" type="radio"   value="2" v-model="loan_demand">
                </div>
            </div>

            <!-- <div class="border-gray-200 border-2 p-2 rounded-lg mt-3 w-48 m-auto">
                <button @click="$bvModal.hide('modal-pending')" class="font-bold" > Về trang chủ</button>
            </div> -->
        </div>
    </b-modal>
  </div>
</template>

<script>
import { saveCustomer, generateOtp, verifyOtp, getPartner } from '@/api/otp'
import { setToken, getToken, setMoney, setPartner,setLogo, removeToken, setTimeCountDownPartner, getTimeCountDownPartner, setTimeCountDown, getTimeCountDown, getUtmSource, setUtmSource,setAffSid, getAffSid ,setClickId,getClickId,getUtmMedium,setUtmMedium, getRefer, getVer, setRefer, setVer } from '@/utils/auth'
import SlideHomePageNew from './components/slideHomePageNew.vue'
import FormInput from './components/formInput.vue'
import ListContent from './components/listContent.vue'
import ListPartner from './components/listPartner.vue'
import ModalCmnd from './components/modalCmnd.vue'
import router from "@/router";
import axios from 'axios'
import { encryptRSA, decryptRSA } from '@/utils/genHash'
import { toYMDHMS,toHMDMY } from "@/filters/index"

export default {
    components: {
        SlideHomePageNew,
        FormInput,
        ListContent,
        ListPartner,
        ModalCmnd,
    },
    data() {
        return {
            form: {
                money: '',
                phone: '',
                identity_card_manual: ''
            },
            BackgroundColor: '#f1674a',
            countOtp: 0,
            countDown: 0,
            timeOutSecond: '',
            timeout: true,
            countDownPartner: 0,
            timeoutPartner: true,
            otp1: true,
            otp2: false,
            otp3: false,
            otp4: false,
            otp5: false,
            loading: false,
            loading_otp: false,
            continues: 'Tìm kiếm',
            detect_city: '',
            loan_demand: 0,
            input_check: true,
            loading_step_one: true,
            loading_step_two: false,
        }
    },
    mounted() {
        axios
            .get('https://api.db-ip.com/v2/free/self')
            .then(response => {
                this.detect_ip = response.data.ipAddress;
                this.detect_city = response.data.stateProv;
            })
            .catch(error => {
                console.log(error);
            });
        // this.$bvModal.show('modal-mirae')
    },
    methods: {
        showModal(){
            removeToken()

            this.$bvModal.show('modal-cmnd')
        },
        closeShowModal(){
            this.$bvModal.hide('modal-mirae')
        },
        showResult() {

            // this.$bvModal.show('connect-shb')background: #9AA0A5;
            this.loading_otp = true
            this.BackgroundColor = '#9AA0A5'
            this.continues = 'Đang tìm kiếm'

            // return;
            setTimeout(()=>{
                this.loading_step_one = false
                this.loading_step_two = true
                this.countDownPartner = 5
                this.timeoutPartner = true
                let timeDown = Math.floor(Date.now() / 1000) + 5
                setTimeCountDownPartner(timeDown)
                this.countDownTimerSHB()
            }, 2000);

            return;//đẩy lead cho shb
            removeToken()
            let obj = {
                msisdn: this.form.phone.replaceAll(' ',''),
                money_loan: this.form.money.replaceAll('.',''),
                detect_ip: this.detect_ip,
                detect_city: this.detect_city,
                // identity_card_manual: this.form.identity_card_manual,
                source: getUtmSource(),
                aff_sid: getAffSid(),
                medium: getUtmMedium(),
                click_id: getClickId(),
                domain: window.location.hostname,
                referer: getRefer(),
                version: getVer()
            }
            
            saveCustomer(obj).then(res => {
                if(res.status == 200){
                    setToken(res.token)
                    
                    this.genOtp()
                }else{
                    this.loading_otp = false
                }
            })
        },
        reGenOtp(){
            this.loading = true
            this.otp1 = ''
            this.otp2 = ''
            this.otp3 = ''
            this.otp4 = ''
            let obj = {
                sign: encryptRSA(getToken())
            }
            generateOtp(obj).then(res => {
                if(res.status == 200 || res.status == 0){
                    this.loading = false
                    this.countOtp = res.count_otp
                    this.countDown = 180
                    this.timeout = true
                    let timeDown = Math.floor(Date.now() / 1000) + 180
                    this.timeOutSecond = timeDown
                    setTimeCountDown(timeDown)
                    this.countDownTimer()
                    this.$bvToast.toast('Hệ thống đã gửi lại mã OTP đến số điện thoại ' + this.form.phone + ', quý khách vui lòng thử lại', {
                        title: 'Thành công',
                        variant: 'success',
                        autoHideDelay: 5000,
                        solid: true
                    })
                    this.$bvModal.show('modal-otp')	
                } else {
                    this.$bvToast.toast(res.message, {
                        title: 'Có lỗi xảy ra',
                        variant: 'danger',
                        autoHideDelay: 5000,
                        solid: true
                    })
                }
            })
        },
        genOtp(){
            let obj = {
                sign: encryptRSA(getToken())
            }
            generateOtp(obj).then(res => {
                this.loading_otp = false
                this.$bvModal.hide('modal-cmnd')
                if((res.code != 200 && res.status == 0) || (res.status == 602)){
                    this.$bvModal.show('modal-pending')	
                    var self  = this
                    setTimeout(() => {
                            self.getPartner()
                        },3500);
                }
                else if((res.status == 200 || res.status == 0 ) && res.code == 200){
                    this.countOtp = res.count_otp
                    this.countDown = 180
                    this.timeout = true
                    let timeDown = Math.floor(Date.now() / 1000) + 180
                    this.timeOutSecond = timeDown
                    setTimeCountDown(timeDown)
                    this.countDownTimer()
                    this.$bvModal.show('modal-otp')	
                } else {
                    this.$bvToast.toast(res.message, {
                        title: 'Có lỗi xảy ra',
                        variant: 'danger',
                        autoHideDelay: 5000,
                        solid: true
                    })
                }
            })
        },
        confirmOTP(){

            this.loading = true
            let obj = {
                token: getToken(),
                otp: this.otp1 + this.otp2 + this.otp3 + this.otp4
            }
            verifyOtp(obj).then(res => {
                this.loading = false
                if(res.status == 200 || res.status == 0){
                    this.$bvModal.hide('modal-otp')
                    setToken(res.token)

                    this.$bvModal.show('modal-pending')	
                    this.countDownPartner = 15
                    this.timeoutPartner = true
                    let timeDown = Math.floor(Date.now() / 1000) + 15
                    setTimeCountDownPartner(timeDown)
                    this.countDownTimerPartner()
                    
                    //this.$bvModal.show('modal-pending')	
                    //this.showModalAccept()
                    // var self  = this
                    // setTimeout(() => {
                    //         self.getPartner()
                    //     },3500);
                } else if(res.status == 5) {
                    if(this.countOtp == 3){
                        this.$bvModal.hide('modal-otp')
                        this.form= {
                            money: '',
                            phone: '',
                            identity_card_manual: ''
                        }
                        this.otp1 = ''
                        this.otp2 = ''
                        this.otp3 = ''
                        this.otp4 = ''
                        this.$bvModal._root.$children[0].modal = {
                            title: 'Thông báo',
                            content: 'Cảm ơn quý khách đã đăng ký vay với Vclick. Đối tác cho vay của Vclick sẽ liên lạc với quý khách trong thời gian sớm nhất',
                            btnHome: false,
                            btnClose: true
                        }
                        this.$bvModal.show('modal-vmain-notify')
                    } else {
                        this.$bvToast.toast('Mã OTP đã hết hạn. Vui lòng lấy mã mới.', {
                            title: 'Có lỗi xảy ra',
                            variant: 'danger',
                            autoHideDelay: 5000,
                            solid: true
                        })
                    }
                }  else if(res.status == 4 || res.status == 3) {
                    if(res.count_otp == 3){
                        if(this.countOtp == 3){
                            this.$bvModal.hide('modal-otp')
                            this.form= {
                                    money: '',
                                    phone: '',
                                    identity_card_manual: ''
                                }
                            this.$bvModal._root.$children[0].modal = {
                                title: 'Thông báo',
                                content: 'Cảm ơn quý khách đã đăng ký vay với Vclick. Đối tác cho vay của Vclick sẽ liên lạc với quý khách trong thời gian sớm nhất',
                                btnHome: false,
                                btnClose: true
                            }
                            this.$bvModal.show('modal-vmain-notify')
                        } else {
                            this.$bvToast.toast('Quý khách đã nhập sai OTP ' + res.count_otp + ' lần, vui lòng lấy mã mới', {
                                title: 'Có lỗi xảy ra',
                                variant: 'danger',
                                autoHideDelay: 5000,
                                solid: true
                            })
                        }
                        
                    } else {
                        this.$bvToast.toast(res.message, {
                            title: 'Có lỗi xảy ra',
                            variant: 'danger',
                            autoHideDelay: 5000,
                            solid: true
                        })
                    }
                    
                }
                 else {
                    this.$bvToast.toast(res.message, {
                        title: 'Có lỗi xảy ra',
                        variant: 'danger',
                        autoHideDelay: 5000,
                        solid: true
                    })
                }
            })
        },
        saveDemand(){
            console.log(this.loan_demand);
            saveCustomer({loan_demand: this.loan_demand}).then(res => {
                if(res.status == 200){
                   console.log('save demand success')
                }
            })
        },
        getPartner(){
            let obj = {
                token: getToken()
            }
            getPartner(obj).then(res => {
                if(res.status == 200 || res.status == 0){
                    this.$bvModal.hide('modal-pending')	
                    setMoney(this.form.money)
                    setPartner(res.partner)
                    setLogo(res.logo)
                    if(res.partner != ''){
                        this.showModalAccept()
                    } else {
                        console.log('ok', res.score)
                        if(res.score){
                            this.$router.push({
                                name: 'VUpdateReject'
                            })
                        }else{
                            this.$router.push({
                                name: 'VUpdateStepEnd'
                            })
                        }
                        // this.showModalReject()
                    }
                } else {
                    this.$bvModal.hide('modal-pending')	
                    this.form= {
                                money: '',
                                phone: '',
                                identity_card_manual: ''
                            }
                    this.$bvModal._root.$children[0].modal = {
                        title: 'Thông báo',
                        content: res.message,
                        btnHome: false,
                        btnClose: true
                    }
                    this.$bvModal.show('modal-notify')
                }
            })
        },
        showModalAccept() {
            this.$router.push({
                name: 'VResult'
            })
        },
        showModalReject() {
            this.$router.push({
                name: 'VReject'
            })
        },
        countDownTimerPartner() {
            if (this.countDownPartner > 0 && this.timeoutPartner) {
                this.timeoutPartner = true
                this.countDownPartner = getTimeCountDownPartner() - Math.floor(Date.now() / 1000);

                setTimeout(() => {
                    //this.countDown -= 1
                    this.countDownTimerPartner()
                }, 1000)
            } else {
                this.getPartner()
                this.saveDemand()
                this.timeoutPartner = false
            }
            
        },
        countDownTimerSHB() {
            if (this.countDownPartner > 0 && this.timeoutPartner) {
                this.timeoutPartner = true
                this.countDownPartner = getTimeCountDownPartner() - Math.floor(Date.now() / 1000);

                setTimeout(() => {
                    //this.countDown -= 1
                    this.countDownTimerSHB()
                }, 1000)
            } else {
                this.timeoutPartner = false
                window.location.href = "https://vt.shbfinance.com.vn/?utm_source=vclick"
            }
            
        },
        countDownTimer() {
            if (this.countDown > 0 && this.timeout) {
                this.timeout = true
                this.countDown = getTimeCountDown() - Math.floor(Date.now() / 1000);

                setTimeout(() => {
                    //this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else 
            this.timeout = false
        },
        formatOTP1() {
            var x = this.otp1.replace(/\D/g, '').match(/(\d{0,1})/)
            this.otp1 = x[1]
            if(this.otp1)
                document.getElementById("otp2").focus();
        },
        formatOTP2() {
            var x = this.otp2.replace(/\D/g, '').match(/(\d{0,1})/)
            this.otp2 = x[1]
            if(this.otp2)
                document.getElementById("otp3").focus();
            else
                document.getElementById("otp1").focus();
        },
        formatOTP3() {
            var x = this.otp3.replace(/\D/g, '').match(/(\d{0,1})/)
            this.otp3 = x[1]
            if(this.otp3)
                document.getElementById("otp4").focus();
            else
                document.getElementById("otp2").focus();
        },
        formatOTP4() {
            var x = this.otp4.replace(/\D/g, '').match(/(\d{0,1})/)
            this.otp4 = x[1]
            if(!this.otp4)
                document.getElementById("otp3").focus();
        },
    },
    created() {

        // this.$bvModal._root.$children[0].modal = {
        //     title: 'Thông báo',
        //     content: 'Thời gian nghỉ lễ từ 29/04/2023 - 02/05/2023. Các khoản vay của quý khách sẽ được xử lý sau kì nghỉ lễ. Kính chúc Quý khách cùng gia đình một kỳ nghỉ lễ vui vẻ, bình an!',
        //     btnHome: false,
        //     btnClose: true
        // }

        // this.$bvModal.show('modal-vmain-notify')

        //console.log(encryptRSA('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjEzIn0.eyJpc3MiOiJhcGkudmNsaWNrLnZuIiwiYXVkIjoiYXBpLnZjbGljay52biIsImp0aSI6IjEzIiwiaWF0IjoxNjc5NTU4ODgyLCJuYmYiOjE2Nzk1NTg4ODIsImV4cCI6MTY3OTU2MjQ4MiwibXNpc2RuIjoiODQ5NjUxMzg3NjciLCJ1aWQiOjEzfQ.XZpxfqNDgtpr0rbdaigKQ0U-MIdm12YgilaUWoEhBXE'))
        //var a = encryptRSA('abc');
        //console.log(decryptRSA(a))
        //if(!getUtmSource()){
            if(this.$route.query.click_id){
                setClickId(this.$route.query.click_id)
            } 

            if(this.$route.query.utm_source){
                setUtmSource(this.$route.query.utm_source)
            } 

            if(this.$route.query.aff_sid){
                setAffSid(this.$route.query.aff_sid)
            } 

            if(this.$route.query.utm_medium){
                setUtmMedium(this.$route.query.utm_medium)
            } 

            if(this.$route.query.v){
                setVer(this.$route.query.v)
            } 

            if(this.$route.query.amount){
                this.form.money = this.$route.query.amount
            } 

            if(document.referrer.length > 0){
                setRefer(document.referrer)
            } 

            //setDomain(window.location.hostname)
            // if(this.$route.query.utm_source){
            //     setDomain(window.location.hostname)
            // } 
        //}

        //console.log(document.body)
        var noscript = document.createElement('noscript')
        var iframe = document.createElement('iframe')
        iframe.setAttribute("id", "no_1")
        iframe.setAttribute('src', "https://www.googletagmanager.com/ns.html?id=GTM-WXJDLFQ")
        iframe.setAttribute("height", "0")
        iframe.setAttribute("width", "0")
        iframe.setAttribute("style", "display:none;visibility:hidden")
        noscript.appendChild(iframe)
        document.body.prepend(noscript)

        //(document.body.noscript).appendChild('<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WXJDLFQ" height="0" width="0" style="display:none;visibility:hidden"></iframe>');
    },
    head: {
        meta: [
            { name: 'google-site-verification', content: 'mpzAtQQKJHEp8KihA5NgLOd7tjUfHcYBeL49exqCfiU' },
            { name: 'facebook-domain-verification', content: 'vxacedff7lilo4oz4g6ue81rboarc0' },
            { name: 'description', content: 'Duyệt vay dễ dàng, tỉ lệ giải ngân cao' },
        ],
        script: [
            { type: 'text/javascript', src: window.location.origin + router.options.base + '/script/home_page.js'},
            { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=AW-10851243888' ,  async: true,},
        ],
        noscript: [
            {
                inner: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1361189891010235&ev=PageView&noscript=1"/>'
            }
        ],
        link: [
            {
                rel: 'canonical', href: 'https://vclick.vn/'
            },
            {
                rel: 'alternate', href: 'https://vclick.vn/'
            },
            {
                rel: 'preconnect', href: 'https://fonts.googleapis.com'
            },
            {
                rel: 'alternate', href: 'https://fonts.gstatic.com'
            },
            {
                rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap'
            }
        ]
    }

}
</script>

<style>
#modal-mirae___BV_modal_content_ {
    background: none;
    border: none;
}
.close_modal {
    float: right;
    position: absolute;
    cursor: pointer;
    margin-left: 90%;
    margin-top: -16px;
}
#connect-shb___BV_modal_body_ {
    padding: 26px;
    font-size: 18px;
}
</style>